export default(event) => {
    try {
        //console.log(event);
        window?.sendEvent(event);
    } catch (error) {
        // Swallow the exception
    }
};
